import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./AppleButton.module.css";
import { cx } from "../cx";

export type AppleButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  /** 버튼 문구("Apple로 시작하기"). 앱이 i18n으로 넘긴다. */
  children: ReactNode;
  block?: boolean;
  loading?: boolean;
};

/**
 * Sign in with Apple 버튼(Apple HIG: 검정 배경·흰 로고·최소 44px 높이, 로고는 글자 높이와 맞춘다).
 * ActionButton large(52px)와 같은 높이·모서리로 Google 버튼 아래에 나란히 선다.
 */
export function AppleButton({ className, block = false, loading = false, disabled, children, type = "button", ...rest }: AppleButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.root, block && styles.block, loading && styles.loading, className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      <span className={styles.label}>
        <AppleLogo />
        {children}
      </span>
      {loading && <span className={styles.spinner} aria-hidden />}
    </button>
  );
}

/** Apple 로고(흰색, currentColor). */
function AppleLogo() {
  return (
    <svg className={styles.logo} width="18" height="18" viewBox="0 0 170 170" aria-hidden focusable="false">
      <path
        fill="currentColor"
        d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.2-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.26 2.13-9.5 3.24-12.74 3.35-4.93.21-9.84-1.96-14.74-6.52-3.13-2.73-7.05-7.41-11.74-14.04-5.04-7.09-9.18-15.31-12.42-24.69-3.47-10.13-5.21-19.94-5.21-29.44 0-10.88 2.35-20.26 7.06-28.13 3.7-6.32 8.63-11.3 14.8-14.96 6.17-3.66 12.83-5.52 20.01-5.64 3.92 0 9.06 1.21 15.45 3.59 6.37 2.39 10.46 3.6 12.25 3.6 1.34 0 5.88-1.42 13.57-4.24 7.27-2.62 13.41-3.7 18.44-3.28 13.63 1.1 23.87 6.47 30.68 16.15-12.19 7.39-18.22 17.73-18.1 31 .11 10.34 3.86 18.94 11.23 25.77 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.12-2.97 15.7-8.88 22.72-7.13 8.35-15.76 13.17-25.12 12.41a25.27 25.27 0 0 1-.19-3.07c0-7.79 3.39-16.13 9.42-22.95 3.01-3.45 6.83-6.32 11.47-8.61 4.63-2.26 9.01-3.5 13.13-3.72.12 1.08.17 2.15.17 3.22z"
      />
    </svg>
  );
}
